import { api } from '@/global/api'
import { TrackingInfo } from '@/modules/simulator/api/types'

export interface CreateSimulationPayload {
  companyEmployees: string
  companyCity: string
  companyCnpj: string
  companyName?: string
  responsibleName: string
  responsiblePhone: string
  responsibleEmail: string
  findOutAlice?: string
  trackingInfo: TrackingInfo
}

export const createSimulation = async (payload: CreateSimulationPayload) => {
  await api.post('/v2/simulation', payload)
}
